import _ from '@dh-fe/translate';
import bgOranum from './assets/section4Oranum.jpg';
import bgOranumMobile from './assets/section4MobileOranum.jpg';

interface Content {
    title: string;
    bg: string;
    bgMobile: string;
}

const oranumContent: Content = {
    title: _`All set to live the {site} life?`.withData({ site: 'Oranum' }),
    bg: bgOranum,
    bgMobile: bgOranumMobile,
};

// eslint-disable-next-line import/prefer-default-export
export const getContent = (): Content => {
    return oranumContent;
};
